import LangEnum from '../../../lang/LangEnum';
import { NavigationColorMode } from '../enums/navigationColorMode.enum';

export const CATALOG_CREATION_NAVIGATION_COLOR_MODES: NavigationColorMode[] = [
  NavigationColorMode.ALL_COLORS,
  NavigationColorMode.CATALOG_PRODUCT_COLORS,
];

export const CATALOG_CREATION_NAVIGATION_COLOR_MODE_LANG: Record<NavigationColorMode, LangEnum> = {
  [NavigationColorMode.ALL_COLORS]: LangEnum.CATALOGS_CREATION_MODAL_DISPLAYED_COLORS_ALL,
  [NavigationColorMode.CATALOG_PRODUCT_COLORS]:
    LangEnum.CATALOGS_CREATION_MODAL_DISPLAYED_COLORS_CATALOG,
};
